export const STATUS = {
  inProgress: 'inProgress',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  ENTRUST: 'ENTRUST',
};
export const STATUS_zh = {
  inProgress: '未处理',
  ERROR: '已拒绝',
  SUCCESS: '已接受',
  ENTRUST: '已委托其他律所',
};
export const TYPE = {
  PERSONAL: 'PERSONAL',
  ENTERPRISE: 'ENTERPRISE'
};
export const TYPE_zh = {
  PERSONAL: '个人身份认证',
  ENTERPRISE: '企业资质认证'
};
